import { useEffect, useState } from "react";

import { SupportedCollaterals } from "@astrid-dao/lib-base";
import { useAccount } from "wagmi";

import { DashboardDecimal18 } from "../next_version/components/Dashboard/models/decimals/DashboardDecimal18";
import { getTokenBalance } from "../next_version/rpc-contract-service/service";

export default function useTokenBalance(symbol: SupportedCollaterals) {
  const [balance, setBalance] = useState(DashboardDecimal18.ZERO);
  const { address } = useAccount();
  const refetchTokenBalanceFlag = window.localStorage.getItem("refetchTokenBalanceFlag");

  useEffect(() => {
    if (address) {
      getTokenBalance(address, symbol)
        .then(rep => {
          setBalance(rep);
        })
        .catch(e => console.log(e));
    }
  }, [address, symbol, refetchTokenBalanceFlag]);

  return balance;
}
